import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate' //Save state to LocalStorage


Vue.use(Vuex)

import defaultState from './defaultState'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

// Modules
import example from './modules/example'
import authentication from './modules/authentication'
import user from './modules/user'
import exhibitor from '@/store/modules/exhibitor';
import events from '@/store/modules/events';
import entityStatus from '@/store/modules/entityStatus';

export default new Vuex.Store({
  state: defaultState,
  getters,
  actions,
  mutations,
  modules: {
    example,
    authentication,
    user,
    exhibitor,
    events,
    entityStatus


  },
  plugins: [createPersistedState()]
})
